import React from "react";
import { createSvgIcon } from "@mui/material/utils";
const Plus = createSvgIcon(/*#__PURE__*/React.createElement("path", {
  d: "M15.5 7.5H8.5V0.5C8.5 0.223877 8.27612 0 8 0C7.72388 0 7.5 0.223877 7.5 0.5V7.5H0.5C0.223877 7.5 0 7.72388 0 8C0 8.27612 0.223877 8.5 0.5 8.5H7.5V15.5005C7.50018 15.7766 7.724 16.0002 8 16H8.00061C8.27655 15.9998 8.50018 15.776 8.5 15.5V8.5H15.5C15.7761 8.5 16 8.27612 16 8C16 7.72388 15.7761 7.5 15.5 7.5Z"
}), "Plus");
export default Plus;